import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[ddiCode]',
    standalone: false
})
export class DdiCodeDirective {
	constructor(private el: ElementRef) {}

	@HostListener('change', ['$event']) onChange(event: Event) {
		this.replaceDDICode();
	}

	@HostListener('input', ['$event']) onInput(event: Event) {
		this.replaceDDICode();
	}

	private replaceDDICode() {
		const inputValue: string = this.el.nativeElement.value;
		// Aplica a lógica de substituição/formato do código DDI desejado
		const formattedValue: string = this.formatDdiCode(inputValue);
		this.el.nativeElement.value = formattedValue;
	}

	private formatDdiCode(value: string): string {
		// Implemente a lógica de formatação do código DDI conforme necessário
		// Exemplo: Remover caracteres não numéricos e adicionar o sinal de "+" no início
		const numericValue: string = value.replace(/\D/g, '');
		return `+${numericValue}`;
	}
}
